import { ApiConfigResponse, getRequestConfig, withMakeRequest } from '~/api';
import Request from '~/api/Request.ts';
import { PaginationBaseRequest } from '../types/pagination';
import { DeleteMultiApplicationByIdRequest } from '../types/multiApplication';

const getApplicationList: (
  request: {
    includeAllClientsFilter?: boolean;
  } & PaginationBaseRequest
) => Promise<ApiConfigResponse> = withMakeRequest(
  async ({ pageSize, pageToken, includeAllClientsFilter }) => {
    const queryParams = new URLSearchParams({
      ...(includeAllClientsFilter && { 'filter.client_type': 'ALL' }),
      ...(pageToken && { page_token: pageToken }),
      ...(pageSize && { page_size: pageSize })
    });
    return await Request.getInstance().get(
      `/clients?${queryParams.toString()}`,
      getRequestConfig({ addEnvDomain: true })
    );
  },
  (data: ApiConfigResponse) => data
);

const deleteApplicationById: (
  request: DeleteMultiApplicationByIdRequest
) => Promise<boolean> = withMakeRequest(
  async ({ applicationId }: DeleteMultiApplicationByIdRequest) => {
    return await Request.getInstance().delete(
      `/clients/${applicationId}`,
      getRequestConfig({ addEnvDomain: true })
    );
  },
  (_) => true
);

export { getApplicationList, deleteApplicationById };
